<!-- Skeleton -->
@if (isLoading()) {
<div class="grid gap-6 lg:grid-cols-[minmax(0,1fr)_340px]" aria-busy="true" aria-label="Cargando tu perfil">
  <div class="space-y-6">
    <div class="h-24 animate-pulse rounded-2xl bg-gray-100 dark:bg-white/[0.04]"></div>
    <div class="space-y-4 rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
      @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
      <div class="h-11 animate-pulse rounded-lg bg-gray-100 dark:bg-white/[0.05]"></div>
      }
    </div>
  </div>
  <div class="hidden h-[420px] animate-pulse rounded-2xl bg-gray-100 dark:bg-white/[0.04] lg:block"></div>
</div>
} @else {

<!-- Live preview of the public microsite, used in the side column and in the mobile disclosure -->
<ng-template #micrositePreview>
  <div class="pf-preview" aria-label="Vista previa de tu micrositio">
    <div class="pf-preview__bar">
      <svg class="size-3 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 018 0v4" />
      </svg>
      <span class="truncate">{{ slugPrefix }}<strong>{{ publicSlugControl.value || 'tu-negocio' }}</strong></span>
    </div>
    <div class="pf-preview__banner" [style.background]="bannerGradient()"></div>
    <div class="relative -mt-9 px-5 pb-5">
      @if (businessLogoPreview()) {
      <img [src]="businessLogoPreview()!" alt="" class="pf-preview__logo object-cover" />
      } @else {
      <div class="pf-preview__logo flex items-center justify-center text-lg font-bold"
        [style.background]="logoGradient()" [style.color]="textOn(primaryColor())">
        {{ businessInitials() }}
      </div>
      }
      <p class="mt-3 text-lg font-bold leading-tight text-gray-900 dark:text-white">
        {{ profileForm.value.businessName || 'Nombre de tu negocio' }}
      </p>
      @if (businessTypeName()) {
      <p class="mt-0.5 text-theme-xs font-medium text-gray-500 dark:text-gray-400">{{ businessTypeName() }}</p>
      }
      @if (profileForm.value.businessDescription) {
      <p class="pf-preview__desc mt-3 text-theme-xs leading-relaxed text-gray-600 dark:text-gray-300">
        {{ profileForm.value.businessDescription }}
      </p>
      } @else {
      <p class="mt-3 text-theme-xs text-gray-400 dark:text-gray-500">
        Aquí aparecerá la descripción de tu negocio.
      </p>
      }
      @if (profileForm.value.address) {
      <p class="mt-3 flex gap-1.5 text-theme-xs text-gray-600 dark:text-gray-300">
        <svg class="mt-px size-3.5 shrink-0" [style.color]="primaryColor()" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 21s-7-5.5-7-11a7 7 0 0114 0c0 5.5-7 11-7 11z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
        {{ profileForm.value.address }}
      </p>
      }
      <div class="mt-4 flex gap-2">
        <span class="pf-preview__cta flex-1" [style.background-color]="primaryColor()"
          [style.color]="textOn(primaryColor())">Reservar cita</span>
        @if (previewWhatsApp()) {
        <span class="pf-preview__wa" title="Botón de WhatsApp">
          <svg class="size-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
        </span>
        }
      </div>
    </div>
  </div>
</ng-template>

<form [formGroup]="profileForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_340px]">

    <!-- ── Main column ── -->
    <div class="min-w-0 space-y-6">

      <!-- Identity strip -->
      @if (!isImpersonating()) {
      <div class="flex flex-wrap items-center gap-x-6 gap-y-4">
        <div class="flex min-w-0 flex-1 items-center">
          <app-avatar></app-avatar>
          <div class="min-w-0">
            <p class="truncate text-lg font-semibold text-gray-900 dark:text-white">
              {{ profileForm.value.fullName || 'Tu nombre' }}
            </p>
            <p class="truncate text-theme-sm text-gray-500 dark:text-gray-400">
              {{ profileForm.value.email }}
              <span class="text-gray-400 dark:text-gray-500">
                ({{ isGoogleLinked() ? 'inicias sesión con Google' : 'inicias sesión con correo y contraseña' }})
              </span>
            </p>
          </div>
        </div>
        @if (savedSlug()) {
        <div class="flex gap-2">
          <button type="button" class="pf-btn pf-btn--ghost" (click)="copySlugUrl()">
            <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="9" y="9" width="13" height="13" rx="2" />
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
            </svg>
            Copiar enlace
          </button>
          <button type="button" class="pf-btn pf-btn--ghost" (click)="openMicrositePreview()">
            <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
              <path d="M15 3h6v6M10 14L21 3" />
            </svg>
            Ver micrositio
          </button>
        </div>
        }
      </div>
      }

      <!-- Mobile preview -->
      <details class="pf-disclosure lg:hidden">
        <summary class="pf-disclosure__summary">
          Ver cómo te ven tus clientes
          <svg class="pf-disclosure__chevron size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </summary>
        <div class="px-4 pb-4">
          <ng-container *ngTemplateOutlet="micrositePreview"></ng-container>
        </div>
      </details>

      <div class="pf-panel">

        <!-- ── Tu cuenta ── -->
        @if (!isImpersonating()) {
        <section class="pf-section" aria-labelledby="pf-account">
          <div class="pf-section__intro">
            <h2 id="pf-account" class="pf-section__title">Tu cuenta</h2>
            <p class="pf-section__help">Solo tú y tu equipo ven estos datos.</p>
          </div>
          <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div class="sm:col-span-2">
              <label for="pf-fullName" class="pf-label">Nombre completo</label>
              <input id="pf-fullName" type="text" formControlName="fullName" autocomplete="name"
                placeholder="María López García" class="pf-input"
                [class.pf-input--error]="fullNameControl.invalid && fullNameControl.touched"
                [attr.aria-invalid]="fullNameControl.invalid && fullNameControl.touched"
                aria-describedby="pf-fullName-msg" />
              @if (fullNameControl.invalid && fullNameControl.touched) {
              <p id="pf-fullName-msg" class="pf-error">Escribe tu nombre y apellido (mínimo 3 letras).</p>
              }
            </div>
            <div>
              <app-country-select formControlName="countryId" [label]="'País'" [required]="true"></app-country-select>
              @if (countryControl.invalid && countryControl.touched) {
              <p class="pf-error">Elige tu país.</p>
              }
            </div>
            <div>
              <label for="pf-phone" class="pf-label">Tu teléfono <span class="pf-optional">opcional</span></label>
              <input id="pf-phone" type="tel" formControlName="phone" autocomplete="tel"
                [mask]="phoneMask() || undefined" [attr.placeholder]="phonePlaceholder()" class="pf-input" />
            </div>
            <div class="sm:col-span-2">
              <p class="pf-label">Correo</p>
              <p class="pf-readonly">{{ profileForm.value.email }}</p>
              <p class="pf-hint">Es tu usuario para iniciar sesión y no se puede cambiar aquí.</p>
            </div>
          </div>
        </section>
        }

        <!-- ── Tu negocio ── -->
        <section class="pf-section" aria-labelledby="pf-business">
          <div class="pf-section__intro">
            <h2 id="pf-business" class="pf-section__title">Tu negocio</h2>
            <p class="pf-section__help">Tus clientes lo ven en tu micrositio de reservas.</p>
          </div>

          <div class="grid grid-cols-1 gap-5 sm:grid-cols-[auto_minmax(0,1fr)]">
            <!-- Logo -->
            <div class="flex items-center gap-4 sm:flex-col sm:items-start sm:gap-2">
              <label class="pf-logo" [class.pf-logo--empty]="!businessLogoPreview()">
                @if (businessLogoPreview()) {
                <img [src]="businessLogoPreview()!" alt="Logo de tu negocio" class="size-full object-cover" />
                <span class="pf-logo__overlay">Cambiar</span>
                } @else {
                <svg class="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <rect x="3" y="3" width="18" height="18" rx="3" />
                  <circle cx="9" cy="9" r="2" />
                  <path d="M21 15l-5-5L5 21" />
                </svg>
                <span class="text-theme-xs font-medium">Subir logo</span>
                }
                <input type="file" accept="image/png,image/jpeg,image/webp" class="sr-only"
                  aria-label="Elegir logo del negocio" (change)="onBusinessLogoSelected($event)" />
              </label>
              <div class="text-theme-xs text-gray-500 dark:text-gray-400 sm:w-24">
                @if (hasPendingLogo) {
                <span class="block font-medium text-gray-700 dark:text-gray-300">Logo nuevo sin guardar</span>
                <button type="button" class="pf-link mt-1" (click)="clearBusinessLogo()">Quitar</button>
                } @else {
                PNG, JPG o WEBP, hasta 5 MB.
                }
              </div>
            </div>

            <div class="space-y-5">
              <div>
                <label for="pf-businessName" class="pf-label">Nombre del negocio</label>
                <input id="pf-businessName" type="text" formControlName="businessName" autocomplete="organization"
                  placeholder="Estudio Belleza Natural" class="pf-input"
                  [class.pf-input--error]="businessNameControl.invalid && businessNameControl.touched"
                  [attr.aria-invalid]="businessNameControl.invalid && businessNameControl.touched" />
                @if (businessNameControl.invalid && businessNameControl.touched) {
                <p class="pf-error">Escribe el nombre de tu negocio (mínimo 3 letras).</p>
                }
              </div>
              <div>
                <label for="pf-businessType" class="pf-label">Tipo de negocio</label>
                <select id="pf-businessType" formControlName="businessTypeId" class="pf-input">
                  <option value="">{{ businessTypes().length ? 'Elige el que mejor te describa' : 'Cargando…' }}</option>
                  @for (type of businessTypes(); track type.businessTypeId) {
                  <option [value]="type.businessTypeId">{{ type.name }}</option>
                  }
                </select>
              </div>
            </div>

            <div class="sm:col-span-2">
              <div class="flex items-baseline justify-between gap-3">
                <label for="pf-description" class="pf-label">Descripción <span class="pf-optional">opcional</span></label>
                <span class="text-theme-xs tabular-nums"
                  [class.text-gray-400]="descriptionLength() <= descriptionMaxLength"
                  [class.text-error-500]="descriptionLength() > descriptionMaxLength">
                  {{ descriptionLength() }}/{{ descriptionMaxLength }}
                </span>
              </div>
              <textarea id="pf-description" formControlName="businessDescription" rows="4" class="pf-input pf-textarea"
                placeholder="Cuéntales qué haces, tu especialidad y qué hace especial tu atención."></textarea>
              @if (descriptionLength() > descriptionMaxLength) {
              <p class="pf-error">Acorta la descripción a {{ descriptionMaxLength }} caracteres.</p>
              }
            </div>
          </div>
        </section>

        <!-- ── Contacto ── -->
        <section class="pf-section" aria-labelledby="pf-contact">
          <div class="pf-section__intro">
            <h2 id="pf-contact" class="pf-section__title">Contacto para clientes</h2>
            <p class="pf-section__help">Cómo te encuentran y te escriben desde el micrositio.</p>
          </div>
          <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div class="sm:col-span-2">
              <label for="pf-address" class="pf-label">Dirección <span class="pf-optional">opcional</span></label>
              <input id="pf-address" type="text" formControlName="address" autocomplete="street-address"
                placeholder="Calle 46 # 10b-17, Soledad, Atlántico" class="pf-input" />
              <p class="pf-hint">
                Tus clientes podrán abrirla en Google Maps.
                @if (mapsUrl()) {
                <a [href]="mapsUrl()" target="_blank" rel="noopener" class="pf-link">Comprobar ubicación</a>
                }
              </p>
            </div>
            <div>
              <label for="pf-businessPhone" class="pf-label">Teléfono del negocio <span class="pf-optional">opcional</span></label>
              <input id="pf-businessPhone" type="tel" formControlName="businessPhone" placeholder="+57 300 123 4567"
                class="pf-input" />
              <p class="pf-hint">Incluye el código de país, por ejemplo +57.</p>
            </div>
            <div>
              <label for="pf-whatsapp" class="pf-label">WhatsApp <span class="pf-optional">opcional</span></label>
              <input id="pf-whatsapp" type="tel" formControlName="businessWhatsApp" placeholder="+57 300 123 4567"
                class="pf-input" />
              <label class="mt-2.5 flex cursor-pointer items-center gap-2.5">
                <input type="checkbox" role="switch" formControlName="whatsAppSameAsPhone" class="pf-switch" />
                <span class="text-theme-sm text-gray-600 dark:text-gray-300">Es el mismo número del negocio</span>
              </label>
            </div>
          </div>
        </section>

        <!-- ── Enlace y colores ── -->
        <section class="pf-section" aria-labelledby="pf-brand">
          <div class="pf-section__intro">
            <h2 id="pf-brand" class="pf-section__title">Enlace y colores</h2>
            <p class="pf-section__help">La dirección que compartes para recibir reservas y los colores de tu página.</p>
          </div>

          <div class="space-y-6">
            <div>
              <label for="pf-slug" class="pf-label">Tu enlace de reservas</label>
              <div class="pf-slug"
                [class.pf-slug--error]="(publicSlugControl.invalid && publicSlugControl.touched) || slugValidationState().isValid === false || slugValidationState().isAvailable === false"
                [class.pf-slug--ok]="slugValidationState().isValid === true && slugValidationState().isAvailable === true">
                <span class="pf-slug__prefix">{{ slugPrefix }}</span>
                <input id="pf-slug" type="text" formControlName="publicSlug" placeholder="mi-negocio"
                  autocomplete="off" autocapitalize="off" spellcheck="false" class="pf-slug__input"
                  aria-describedby="pf-slug-status" />
                <span class="pf-slug__icon" aria-hidden="true">
                  @if (slugValidationState().isValidating) {
                  <svg class="size-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                  } @else if (slugValidationState().isValid === true && slugValidationState().isAvailable === true) {
                  <svg class="size-4 text-success-500" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                  } @else if (slugValidationState().isValid === false || slugValidationState().isAvailable === false) {
                  <svg class="size-4 text-error-500" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  }
                </span>
              </div>
              <p id="pf-slug-status" class="pf-hint" aria-live="polite">
                @if (publicSlugControl.invalid && publicSlugControl.touched) {
                <span class="text-error-500">
                  @if (publicSlugControl.hasError('required')) { Escribe un enlace para tu negocio. }
                  @else if (publicSlugControl.hasError('minlength')) { Usa al menos 3 caracteres. }
                  @else if (publicSlugControl.hasError('maxlength')) { Usa máximo 100 caracteres. }
                  @else { Usa solo letras minúsculas, números y guiones; no termines con guion. }
                </span>
                } @else if (slugValidationState().isValidating) {
                Revisando si está disponible…
                } @else if (slugValidationState().message) {
                <span [class.text-success-600]="slugValidationState().isAvailable === true"
                  [class.text-error-500]="slugValidationState().isAvailable === false || slugValidationState().isValid === false">
                  {{ slugValidationState().message }}
                </span>
                } @else {
                Letras minúsculas, números y guiones. Los espacios se convierten en guiones.
                }
              </p>
              @if (savedSlug() && isSlugChanged()) {
              <p class="pf-notice mt-3">
                Al guardar, el enlace anterior <strong>{{ slugPrefix }}{{ savedSlug() }}</strong> dejará de funcionar.
                Actualízalo donde lo hayas compartido.
              </p>
              }
            </div>

            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
              @for (c of [
                { key: 'primaryColor', label: 'Color principal', help: 'Botones y detalles.', value: primaryColor() },
                { key: 'secondaryColor', label: 'Color secundario', help: 'Acompaña al principal en el fondo.', value: secondaryColor() }
              ]; track c.key) {
              <fieldset>
                <legend class="pf-label">{{ c.label }}</legend>
                <div class="flex flex-wrap items-center gap-2">
                  @for (hex of colorPresets; track hex) {
                  <button type="button" class="pf-swatch" [style.background-color]="hex"
                    [attr.aria-pressed]="c.value.toLowerCase() === hex"
                    [attr.aria-label]="c.label + ' ' + hex"
                    (click)="setColor($any(c.key), hex)"></button>
                  }
                  <label class="pf-swatch pf-swatch--custom" [title]="'Elegir otro ' + c.label.toLowerCase()"
                    [attr.data-active]="!colorPresets.includes(c.value.toLowerCase())"
                    [style.background-color]="colorPresets.includes(c.value.toLowerCase()) ? null : c.value">
                    <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round" aria-hidden="true">
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                    <input type="color" class="sr-only" [formControlName]="c.key"
                      [attr.aria-label]="'Elegir otro ' + c.label.toLowerCase()" />
                  </label>
                </div>
                <p class="pf-hint">{{ c.help }} <span class="tabular-nums">{{ c.value }}</span></p>
              </fieldset>
              }
            </div>
          </div>
        </section>

        <!-- ── Contraseña ── -->
        @if (!isImpersonating()) {
        <section class="pf-section" aria-labelledby="pf-security">
          <div class="pf-section__intro">
            <h2 id="pf-security" class="pf-section__title">Contraseña</h2>
            <p class="pf-section__help">Cámbiala solo si lo necesitas.</p>
          </div>
          @if (isGoogleLinked()) {
          <p class="pf-readonly flex items-center gap-2.5">
            <svg class="size-4 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0012 23z" />
              <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 015.5 12c0-.73.13-1.44.34-2.1V7.06H2.18A11 11 0 001 12c0 1.77.43 3.45 1.18 4.94l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 002.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
            </svg>
            <span>Entras con tu cuenta de Google, así que tu contraseña se cambia en Google.</span>
          </p>
          } @else {
          <div class="max-w-md">
            <label for="pf-password" class="pf-label">Nueva contraseña</label>
            <div class="relative">
              <input id="pf-password" [type]="showPassword() ? 'text' : 'password'" formControlName="password"
                autocomplete="new-password" placeholder="Déjala vacía para no cambiarla" class="pf-input pr-12" />
              <button type="button" class="pf-eye" (click)="showPassword.set(!showPassword())"
                [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                [attr.aria-pressed]="showPassword()">
                @if (showPassword()) {
                <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19M1 1l22 22" />
                  <path d="M14.12 14.12a3 3 0 11-4.24-4.24" />
                </svg>
                } @else {
                <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                }
              </button>
            </div>
          </div>
          }
        </section>
        }
      </div>

      <!-- Save bar -->
      @let changes = changedSections();
      <div class="pf-savebar" [class.pf-savebar--dirty]="hasChanges()" role="region" aria-label="Guardar cambios">
        <p class="pf-savebar__status text-theme-sm" aria-live="polite">
          @if (hasChanges()) {
          Cambios sin guardar{{ changes.length ? ' en ' + changes.join(', ') : '' }}
          } @else {
          Todo está guardado
          }
        </p>
        <div class="flex gap-2">
          @if (hasChanges()) {
          <button type="button" class="pf-btn pf-btn--ghost" (click)="onReset()" [disabled]="isSaving()">
            Descartar
          </button>
          }
          <button type="submit" class="pf-btn pf-btn--primary" [disabled]="isSaving() || !hasChanges()">
            @if (isSaving()) {
            <svg class="size-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
            Guardando…
            } @else {
            Guardar cambios
            }
          </button>
        </div>
      </div>
    </div>

    <!-- ── Side column: live preview ── -->
    <aside class="sticky top-24 hidden lg:block" aria-labelledby="pf-preview-title">
      <h2 id="pf-preview-title" class="text-theme-sm font-semibold text-gray-800 dark:text-white/90">
        Así te ven tus clientes
      </h2>
      <p class="mb-3 mt-0.5 text-theme-xs text-gray-500 dark:text-gray-400">Se actualiza mientras escribes.</p>
      <ng-container *ngTemplateOutlet="micrositePreview"></ng-container>
    </aside>
  </div>
</form>
}
